/**********************************************
  EXPANDERS EXPLAINED:

  Take a route from of the sitemap generation process,
  return a promise for thenable routes - to be flattened when the sitemap is generated

*//////////////////////////////////////////////

import moment from "moment-timezone";

import logger from 'logger';
import config from "config";
import ApiClient from "utils/ApiClient";
import { slugifyName } from "utils";
import { isInThePast, getRelativeDay } from "utils/LocalDateTimeHelper";

import { nDayArrFactoryBackwards, nDayArrFactoryBoth, stripTZD } from "utils/sitemapUtils";

const client = new ApiClient();

export function resultsDateExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryBackwards();

  return new Promise(resolve => {
    for (const date of dateArray) {
      let urlDate = getRelativeDay(date, 0, {convertYesterday: true});
      routeArray.push({ url: url.replace(":date", urlDate), sitemap: {changefreq, priority}});
    }
    return resolve(routeArray);
  });
}

export function racecardExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryBoth();

  const promiseStack = [];

  for (const date of dateArray) {
    // We need to presume that the provided timezone is UTC. That way it won"t be changed when valueOf converts to UTC.
    const startDate = moment.tz(date, "UTC").startOf("day");

    promiseStack.push(
      client.get(config.api.greyhoundRacing.loadMeetings, {
        params : {
          from: startDate.valueOf(),
          to: moment(startDate).add(1, "day").valueOf()
        }
      })
      .then(result => result)
      .catch(err => {
        logger.debug(err);
        return [];
      })
    );
  }

  return Promise.all(promiseStack)
    .then(results => {
      for (const day of results) {
        for (const {meeting_summary, races} of day) {
          const {
            date: meetingDate,
            course: {
              name: courseName
            }
          } = meeting_summary;
          for (const {race_summary_reference: { id: raceId }, date: raceDate, time: raceTime, off_time: raceOffTime} of races) {
            if (meetingDate && courseName && raceId) {
              const isInPast = raceOffTime ? isInThePast(`${raceDate}T${raceOffTime}Z`) : isInThePast(`${raceDate}T${raceTime}Z`);
              routeArray.push({
                url: url.replace(":date", meetingDate)
                        .replace(":courseSlug", slugifyName(courseName))
                        .replace(":raceId", raceId),
                sitemap: {
                  changefreq,
                  priority,
                  lastmodISO: isInPast ?
                    raceOffTime ?
                      `${raceDate}T${stripTZD(raceOffTime)}Z`
                    :
                      `${raceDate}T${stripTZD(raceTime)}Z`
                  :
                    undefined
                }
              });
            }else{
              logger.debug(`The following greyhound race has an issue, and won't be added to the sitemap: ${meetingDate} ${courseName} ${raceId}`);
            }
          }
        }
      }
      return routeArray;
    });
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/sitemap-helper.js